import React from 'react';

import { Input, FormGroup, Label, FormFeedback, FormText } from 'reactstrap';

function SelectFieldGroup(props) {
    const { field, value, label, error, onChange, description, className } = props;

    return (
        <FormGroup className={className}>
            <Label for={field}>{label}</Label>
            <Input
                type="select"
                name={field}
                value={value || ""}
                onChange={onChange}
                invalid={error ? true : false}
            >
                {props.children}
            </Input>
            {error && <FormFeedback>{error}</FormFeedback>}
            {description && <FormText>{description}</FormText>}
        </FormGroup>
    );
}

export default SelectFieldGroup;
